import React, { useState } from 'react'
import './bottom-section.scss'

import { useIsDomContentVisibleOnce } from '../../../hooks/useIsDomContentVisible'

import { navigate } from 'gatsby'
import Button from '../../atoms/button/button'

import TopPlayersTable from '../top-players/table/top-players-table'
import CurrentPlayerInfo from '../top-players/current-info/current-player-info'
import SectionTitleDivisor from '../../atoms/section-title-divisor/section-title-divisor'
import VBot from './v-bot'

function BottomContent() {
  return (
    <div className="f-bottom-section__wrapper">
      <div className="f-bottom-section__side">
        <CurrentPlayerInfo />
        <Button
          title="jugemos"
          onClick={() => navigate('/play')}
          className="btn-play"
          data={{ 'data-tag': '7A', 'data-href': '/play' }}
        >
          JUGAR
        </Button>
      </div>

      <VBot />

      <div className="f-bottom-section__side">
        <TopPlayersTable />
      </div>
    </div>
  )
}

export default function BottomSection({ id = '' }) {
  const visible = useIsDomContentVisibleOnce('#' + id)
  return (
    <section
      id={id}
      className="f-bottom-section"
      aria-label="Tabla de posiciones, informacion del puntaje del jugador y fecha termino del juego"
    >
      <SectionTitleDivisor>TOP JUGADORAS</SectionTitleDivisor>
      {visible && <BottomContent />}
    </section>
  )
}
